<template>
  <div class="d-flex" @click="$router.push({ path: `/${url}/${slug}` })">
    <i class="d-flex fas fa-th right-icon" :class="[isActive ? 'active-link-icon' : '']"></i>
    <i class="d-flex fas fa-list left-icon" :class="[!isActive ? 'active-link-icon' : '']"></i>
  </div>
</template>

<script>
export default {
  name: 'change-view',
  props: {
    url: {
      type: String,
    },
    isActive: {
      type: Boolean,
    },
  },
  data() {
    return {
      slug: this.$route.params.slug,
    }
  },
}
</script>

<style scoped>
i:first-child {
  margin-left: 6px;
  font-size: 17px;
  width: 30px;
  /* height: 40px; */
  text-align: center;
  align-self: center;
  justify-self: center;
}
i:last-child {
  cursor: pointer;
  padding: 9px 13px;
  color: #495057;
  font-size: 17px;
}
.active-link-icon {
  background-color: #556ee6;
  color: white !important;
  border-radius: 50%;
  padding: 8px 11px;
  width: 40px !important;
  height: 40px;
  justify-content: center;
  align-items: center;
}
</style>
